import { render } from "./EmployeeEdit.vue?vue&type=template&id=1ae85a2c"
import script from "./EmployeeEdit.vue?vue&type=script&lang=js"
export * from "./EmployeeEdit.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueProject\\Cigl-Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__